
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subsets/NCIT-subsets",
      function () {
        return require("private-next-pages/subsets/NCIT-subsets.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subsets/NCIT-subsets"])
      });
    }
  